export default (value) => {
  if (!value || typeof value !== 'string') return ''

  try {
    const cleanValue = value.replace(/[-\s]/g, '')
    return /^\d+$/.test(cleanValue)
      ? cleanValue.replace(/(\d{4})(?=\d)/g, '$1-')
      : ''
  } catch {
    // console.error('Error formatting gift card number')
    return ''
  }
}
